export const validateUser = (user) => {
	if (!user.username.length || !user.password.length) return user;
};
